function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "svg-mono",
  fill: "#355B99",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.065 17.104a4.133 4.133 0 0 1 0-8.264 4.132 4.132 0 1 1 0 8.264m-12.175 0a4.134 4.134 0 0 1-4.136-4.132 4.134 4.134 0 0 1 8.267 0 4.131 4.131 0 0 1-4.131 4.132M19.065 6.082a6.887 6.887 0 0 0-6.087 3.66 6.887 6.887 0 0 0-6.088-3.66c-1.55 0-2.981.512-4.136 1.378V1.655a1.376 1.376 0 0 0-2.754 0v11.431h.002a6.888 6.888 0 0 0 6.888 6.777 6.89 6.89 0 0 0 6.088-3.66 6.89 6.89 0 1 0 6.087-10.121"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.647 17.556L32.9 12.962l3.75-4.603c.474-.607.339-1.455-.316-1.905-.655-.455-1.575-.338-2.082.251v-.001l-3.226 3.954-3.223-3.954v.001c-.502-.59-1.427-.706-2.08-.251-.654.45-.79 1.298-.314 1.905h-.001l3.743 4.603-3.743 4.594h.001c-.476.61-.34 1.455.313 1.907.654.452 1.579.337 2.08-.253l3.224-3.948 3.222 3.948c.507.59 1.426.705 2.082.253.654-.452.79-1.298.316-1.907"
}));

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    viewBox: "0 0 37 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.f5c99f40.svg";
export { ForwardRef as ReactComponent };